
var ajaxLoadRow = ( function ( $, ajaxLoadRow ) {
    'use strict';

    var $content, $contentRows, $messages;
    var editors = {};
    var sliders = {};

    ajaxLoadRow.url  = null;

    ajaxLoadRow.renderError = function(message) {
        var $error = $('<div/>').addClass('alert alert-danger').text(message);
        $messages.empty($messages);
        $messages.append($error);
    };

    ajaxLoadRow.initializeCKEditor = function() {
        const targets = document.querySelectorAll("[data-ckeditor-name]:not(.observed)");
       // console.log(targets.length);

        const lazyLoad = (target)=>{
            const io = new IntersectionObserver((entries,observer)=>{
                entries.forEach(entry=>{
                    if(entry.isIntersecting){
                        var el = entry.target;
                        $(el).addClass('observed');
                        var name = $(el).data('ckeditor-name');
                        //console.log('observed', name);
                        if (typeof editors[name] === 'undefined') {
                            BalloonEditor.create(el, {

                            })
                            .then(editor => {
                                editors[name] = editor;
                            })
                            .catch(error => {
                                console.error('There was a problem initializing the editor.', error);
                            });
                        }
                        observer.disconnect();
                    }
                })
            },{threshold:[0]});

            io.observe(target);
        }
        targets.forEach(lazyLoad);
    };

    // galerie produktu
    ajaxLoadRow.initializeSlider = function(){
        $(".product-thumbnail").each(function(){
            var name = $(this).find('.product-thumbnail-carousel').attr('id');
            if (typeof sliders[name] === 'undefined') {
                var self = $(this);

                var $slider = $(this).find('.product-thumbnail-items').lightSlider({
                    item: 1,
                    controls: false,
                    pager: false,
                    loop: true,
                    adaptiveHeight: true,
                    onBeforeSlide: function(el) {
                        self.find('.product-thumbnail-caption-indicator').text(el.getCurrentSlideCount());
                        var $img = el.find('.lslide').eq(el.getCurrentSlideCount()-1).find('img');
                        $img.attr('src', $img.attr('data-src'));
                    },
                    onSliderLoad: function() {
                        self.find('.product-thumbnail-carousel').removeClass('is-loading');
                    }
                });

                $(this).delegate('.carousel-control-next', 'click', function(e){
                    e.preventDefault();
                    $slider.goToNextSlide();
                });

                $(this).delegate('.carousel-control-prev', 'click', function(e){
                    e.preventDefault();
                    $slider.goToPrevSlide();
                });

                sliders[name] = $slider;

                var lightbox = $(this).find('.product-thumbnail-item').not('.clone').simpleLightbox({
                    sourceAttr: 'data-img',
                    alertError: false,
                });

                var isDragging = false;
                $(this).find('.product-thumbnail-item').not('.clone').mousedown(function() {
                    isDragging = false;
                }).mousemove(function() {
                    isDragging = true;
                }).mouseup(function(e) {
                    var wasDragging = isDragging;
                    isDragging = false;

                    if (!wasDragging && e.button !== 2) {
                        lightbox.open($(this));
                    }
                });
            }
        });

        activeLazyload();
    };

    ajaxLoadRow.renderRow = function(limit, loader = true) {
        var ids = [];
        $contentRows.find('[data-ajaxloadrow-id]').each(function(i, el) {
            ids.push($(el).data('ajaxloadrow-id'));
        });

        if (loader) {
            $('body').addClass('is-loading');
        }

        $.ajax({
            url: ajaxLoadRow.url,
            data: {
                limit: limit,
                renderIds: ids
            },
            success: function(html) {
                if (html) {
                    $contentRows.append(html);
                    window.tooltipStart();
                    ajaxLoadRow.initializeCKEditor();
                    ajaxLoadRow.initializeSlider();
                }
                else if (ids.length === 0) {
                    $('[data-ajaxloadrow-no-item]').show();
                }
                $('body').removeClass('is-loading');
                window.refreshMenuCount();
            }
        });
    };

    ajaxLoadRow.copyEditorToTextArea = function() {
        $.each(editors, function(key, editor) {
            var $editor = $('[data-ckeditor-name="' + key + '"]');
            if ($editor.length) {
                var $textarea = $('textarea[name="' + key + '"]');
                var text = editor.getData();
                $textarea.val(text);
            }
        });
    };

    ajaxLoadRow.actionRow = function($this) {
        var $row = $this.closest('[data-ajaxloadrow-row]');
        var url = window.toTranslateUrlSave; //$row.find('form').data('ajaxloadrow-action-url');
        var action = $this.find('button:focus').data('ajaxloadrow-save');

        $.post({
            url: url,
            data: $this.serialize() + '&action=' + action,
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(data) {
                if (data.status === 'success') {
                    $row.slideUp("slow", function() {
                        $row.remove();

                        // pokud v seznamu jsou stejné fráze, tak je odstraníme, protože předpokládáme, že se přeložili
                        $row.find('[data-textarea-part-text]').each(function(i, el) {
                            var id = $(el).data('textarea-part-text');
                            $content.find('[data-text-part-id="' + id + '"]')
                                .removeClass('active')
                                .addClass('disabled')
                                .removeAttr('data-text-part-id');
                            $content.find('[data-textarea-part-text="' + id + '"]').closest('.phrase-edit-textarea').remove();
                        });

                        ajaxLoadRow.renderRow(1, false);
                    });
                }
                else {
                    ajaxLoadRow.renderError(data.message);
                }
            },
            error: function() {
                ajaxLoadRow.renderError('Response error');
            }
        });
    };

    ajaxLoadRow.initialize = function(renderUrl, limit, extendLockUrl)
    {
        ajaxLoadRow.url = renderUrl;

        $content = $('[data-ajaxloadrow-content]');
        $contentRows = $content.find('[data-ajaxloadrow-rows-content]');
        $messages = $content.find('[data-ajaxloadrow-messages]');

        ajaxLoadRow.renderRow(limit);

        $content.find('[data-ajaxloadrow-next]').on('click', function(ev) {
            ev.preventDefault();
            ajaxLoadRow.renderRow(10, false);
        });

        $content.delegate('aaa[data-ajaxloadrow-save]', 'click', function(ev) {
            ev.preventDefault();

            var $btn = $(this);
            var $form = $(this).closest('form');

            ajaxLoadRow.copyEditorToTextArea();
            ajaxLoadRow.actionRow($form);
        });

        $content.delegate('form', 'submit', function(ev) {
            ev.preventDefault();
            ajaxLoadRow.copyEditorToTextArea();
            ajaxLoadRow.actionRow($(this));
        });

        // pokud mám focus v textaree tak zaktivníme část textu
        $content.delegate('[data-ckeditor-name]', 'focus', function(ev) {
            var name = $(this).data('ckeditor-name');
            var $text = $(this).closest('form').find('[data-text-part-id="' + name + '"]');
            var $allTexts = $('[data-text-part-id]');

            $('.phrase-edit-textarea').removeClass('active');
            $(this).closest('.phrase-edit-textarea').addClass('active');

            $allTexts.removeClass('active');
            $text.addClass('active');

            $(this).closest('.phrase-edit-textarea').addClass('selected');
        });

        $content.delegate('[data-ckeditor-name]', 'focusout', function(ev) {
            $('[data-text-part-id]').removeClass('active');
            $('.phrase-edit-textarea').removeClass('active');
        });

        $content.delegate('[data-text-part-id]', 'click', function(ev) {
            var sel = getSelection().toString();
            if (sel) {
                return false;
            }

            var name = $(this).data('text-part-id');
            var $input = $(this).closest('form').find('[data-ckeditor-name="' + name + '"]');
            if ($(this).is('.ckeditor')) {
                // to translate skip
                $input.closest('.phrase-edit-textarea').addClass('active');
            }
            else {
                // to translate
                $input.focus().select();
            }
        });

        // hover zvyrazneni
        $content.delegate('.phrase-edit-textarea', 'mouseover', function(ev) {
            var name = $(this).find('[data-ckeditor-name]').data('ckeditor-name');
            var $text = $(this).closest('form').find('[data-text-part-id="' + name + '"]');
            var $allTexts = $('[data-text-part-id]');

            $('.phrase-edit-textarea').removeClass('hover');
            $(this).addClass('hover');

            $allTexts.removeClass('hover');
            $text.addClass('hover');
        });

        $content.delegate('.phrase-edit-textarea', 'mouseout', function(ev) {
            $('[data-text-part-id]').removeClass('hover');
            $(this).removeClass('hover');
        });

        $content.delegate('[data-text-part-id]', 'mouseover', function(ev) {
            var name = $(this).data('text-part-id');
            var $input = $(this).closest('form').find('[data-ckeditor-name="' + name + '"]');
            $input.closest('.phrase-edit-textarea').addClass('hover');
            $(this).addClass('hover');
        });

        $content.delegate('[data-text-part-id]', 'mouseout', function(ev) {
            $('.phrase-edit-textarea.hover').removeClass('hover');
            $(this).removeClass('hover');
        });

        // co 5 minut budeme prodlužovat zámky
        if (typeof extendLockUrl !== 'undefined') {
            setInterval(function() {
                var ids = [];
                $contentRows.find('[data-ajaxloadrow-id]').each(function(i, el) {
                    ids.push($(el).data('ajaxloadrow-id'));
                });
                $.ajax({
                    url: extendLockUrl,
                    data: { ids: ids },
                });
            }, ((1000 * 60) * 5));
        }
    };

    return ajaxLoadRow;
}( window.jQuery, ajaxLoadRow || { } ) );

window.ajaxLoadRow = ajaxLoadRow;
